import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import ItemList from 'flarum/common/utils/ItemList';
import LangDisplayName from '../util/LangDisplayName';
import TranslatedPostFooter from './TranslatedPostFooter';
import TranslationSourceLabel from './TranslationSourceLabel';
import { generateActionItems } from '../util/generateActionItems';

/**
 * The translated copy of a post, rendered below it in the post footer exactly
 * like ianm/translate: `CommentPost CommentPost--translated`.
 */
export default class TranslatedCommentPost extends Component {
  view() {
    const {
      state
    } = this.attrs;
    if (state.loading || !state.currentTranslation) {
      return m("div", {
        className: "CommentPost CommentPost--translated"
      }, m(LoadingIndicator, null));
    }
    return m("div", {
      className: "CommentPost CommentPost--translated"
    }, m("div", {
      className: "Post-header"
    }, this.headerItems(state).toArray()), m("div", {
      className: "Post-body",
      dir: app.translator.getLocale() === 'ar' ? 'rtl' : 'ltr'
    }, this.translatedContent(state.currentTranslation)), m("div", {
      className: "Post-footer"
    }, this.footerItems(state).toArray()));
  }
  translatedContent(text) {
    return m.trust(String(text).split(/\n{2,}/).map(paragraph => paragraph.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br>')).map(paragraph => `<p>${paragraph}</p>`).join(''));
  }
  headerItems(state) {
    const items = new ItemList();
    const post = this.attrs.post || state.item;
    const detected = post?.detectedLang?.() || state.detectedLang;
    const from = detected && detected !== 'unknown' ? LangDisplayName(detected) : app.translator.trans('itqan-translate.forum.unknown-language');
    const to = LangDisplayName(state.language);
    items.add('translation-ai', m(TranslationSourceLabel, {
      from: from,
      to: to
    }), 50);
    items.add('actions', m("div", {
      className: "PostMeta PostTranslation--action-items"
    }, generateActionItems(state).toArray()), -100);
    return items;
  }
  footerItems(state) {
    const items = new ItemList();
    items.add('translation-date', m(TranslatedPostFooter, {
      updatedAt: state.updatedAt,
      provider: state.provider
    }), 90);
    return items;
  }
}
flarum.reg.add('itqan-translate', 'forum/components/TranslatedCommentPost', TranslatedCommentPost);